// Auth related constants
export const AUTH_CONSTANTS = {
  COMPANY_NAME: 'GameOps Interactive',
  COPYRIGHT_YEAR: '2025',
  RESTRICTED_ACCESS_MESSAGE: 'Please sign in using your Scaletech Gmail account only',
  WELCOME_MESSAGE: 'Setting Sail for Legacy - One platform to control, clean and connect your data automatically',
  SECURITY_MESSAGE: 'Protected by Google OAuth 2.0 with enterprise-grade security',
} as const;
